export default "__VITE_ASSET__B9toGq8R__"